// Summernote initialization
// Import order matters: jquery-global MUST run before summernote-lite.
// ES modules evaluate depth-first, so jquery-global's body (which sets
// window.jQuery) executes before summernote-lite.min.js is evaluated.
import './jquery-global';
import 'summernote/dist/summernote-lite.css';
import 'summernote/dist/summernote-lite.js';
// Must come after the lib's own CSS
import './summernote-defaults.css';

import { installImageDialogWithDimensions } from './imageDialogWithDimensions';

installImageDialogWithDimensions((window as any).jQuery);
